import { render, staticRenderFns } from "./AddEditAttachment.vue?vue&type=template&id=4a3349b4&"
import script from "./AddEditAttachment.vue?vue&type=script&lang=js&"
export * from "./AddEditAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports